import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext'; // ⬅️ [추가]
import { BrowserRouter } from 'react-router-dom'; // ⬅️ [추가]

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider> {/* ⬅️ [추가] 앱 전체를 감쌈 */}
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);